import React, { useState, useEffect } from "react";
import {
  TextField,
  Grid,
  Container,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Paper,
  Button,
  Fab,
} from "@material-ui/core";
import InputAdornment from "@material-ui/core/InputAdornment";

import EditIcon from "@material-ui/icons/Edit";
// import { makeStyles } from "@material-ui/core/styles";
import Icon from "@material-ui/core/Icon";
import IconButton from "@material-ui/core/IconButton";
import axios from "axios";
import Conf from "./Conf";
// import LinearProgress from "@material-ui/core/LinearProgress";

let cookie = JSON.parse(localStorage.getItem(Conf.cookieName));

export default function Patron() {
  const [state, setState] = useState();
  useEffect(() => {
    (async () => {
      if (cookie && cookie.admin_token) {
        let profile = await axios.get(Conf.signinURL + "me", {
          headers: {
            authorization: cookie.admin_token,
            "X-Requested-With": "profile",
          },
        });
        profile = profile.data.profile;
        if (
          !profile.OrganizationName2 === "ฝ่ายเทคโนโลยีสารสนเทศห้องสมุด" ||
          !profile.OrganizationName2 ===
            "หัวหน้าฝ่ายบริการและส่งเสริมการเรียนรู้"
        ) {
          window.location = Conf.frontendURL + "login";
        } else {
          setState({ profile });
        }
      } else {
        window.location = Conf.frontendURL + "login";
      }
    })();
  }, []);
  async function goSearch(e) {
    let keyword = e.target.value;

    var query = {
      $or: [
        { first_name: { $regex: ".*" + keyword + ".*" } },
        { last_name: { $regex: ".*" + keyword + ".*" } },
        { patron_code: { $regex: ".*" + keyword + ".*" } },
        { email: { $regex: ".*" + keyword + ".*" } },
      ],
    };
    let result = await axios.post(Conf.backendURL + "patron", { query: query });
    if (result.data[0]) setState({ ...state, patronList: result.data });
    else alert("Not found patron");
    console.log(result);
  }
  function selectPatron(patron) {
    setState({ ...state, patronList: null, selectedPatron: patron });
  }
  return (
    <div>
      {state && state.profile && (
        <div>
          <Container maxWidth="lg">
            <Grid container spacing={1}>
              <Grid item xs={7}>
                <h1>Patron Informations</h1>
              </Grid>
              <Grid item xs={5} style={{ paddingTop: "25px" }}>
                <TextField
                  fullWidth
                  id="keyword"
                  label="Search"
                  variant="outlined"
                  placeholder="Keyword..."
                  onKeyUp={(e) => e.key === "Enter" && goSearch(e)}
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
              </Grid>
            </Grid>
            <hr style={{ borderBottom: "2px solid #333" }} />

            <div
              style={{
                textAlign: "right",
                fontSize: ".8rem",
                fontWeight: 400,
              }}
            >
              {state.profile.usn.toUpperCase()} &nbsp; (
              <a href={Conf.frontendURL + "login"} style={{ color: "#f00" }}>
                Sign Out
              </a>
              )
            </div>
            {state.patronList ? (
              <PatronList
                patrons={state.patronList}
                selectPatron={selectPatron}
              />
            ) : (
              <PatronForm patron={state.selectedPatron} />
            )}
          </Container>
        </div>
      )}
    </div>
  );
}

function PatronList({ patrons, selectPatron }) {
  return (
    <div style={{ paddingTop: "20px" }}>
      <TableContainer component={Paper}>
        <Table size="small" aria-label="a dense table">
          <TableBody>
            {patrons.map((patron) => (
              <TableRow key={patron._id}>
                <TableCell>{patron.first_name} </TableCell>
                <TableCell>{patron.last_name}</TableCell>
                <TableCell>{patron.patron_code}</TableCell>
                <TableCell>{patron.email}</TableCell>
                <TableCell style={{ width: "80px", textAlign: "center" }}>
                  <Fab
                    color="secondary"
                    aria-label="edit"
                    size="small"
                    onClick={() => selectPatron(patron)}
                  >
                    <EditIcon />
                  </Fab>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );
}

function PatronForm(props) {
  const [patron, setPatron] = useState();
  useEffect(() => {
    (async () => {
      console.log(props.patron);
      if (props.patron) setPatron(props.patron);
      else {
        setPatron({});
      }
    })();
  }, [props]);

  function updatePatron(profile) {
    if (profile.position_name === "null") profile.position_name = "";
    profile = {
      _id: null,
      cmu_account: profile.cmu_account,
      student_id: profile.student_id,
      prefix: profile.prename_TH,
      first_name: profile.first_name_TH,
      last_name: profile.last_name_TH,
      fullname:
        profile.first_name_TH +
        " " +
        profile.last_name_TH +
        ", " +
        profile.prename_TH,
      cmu_email: profile.cmu_account + "@cmu.ac.th",
      department: profile.department_name_TH,
      organization: profile.faculty_name_TH,
      position: profile.position_name || "",
    };
    setPatron({
      // ...patron,
      ...profile,
    });
  }
  async function searchAccount() {
    let it_account = patron.cmu_account;
    if (it_account) {
      let profile = await axios.post(Conf.itaccount + "/account/index.php", {
        it_account,
      });
      if (!profile || !profile.data || !profile.data[0])
        alert("Not found cmu profile");
      else {
        profile = profile.data[0];
        profile.cmu_account = profile.cmuitaccount;
        updatePatron(profile);
      }
    }
  }
  async function searchStudentId() {
    let student_id = patron.student_id;
    if (student_id) {
      let profile = await axios.post(Conf.itaccount + "/account/index.php", {
        student_id,
      });
      if (!profile || !profile.data || !profile.data[0])
        alert("Not found cmu profile");
      else {
        profile = profile.data[0];
        profile.cmu_account = profile.cmuitaccount;
        updatePatron(profile);
      }
    }
  }
  async function savePatron() {
    let result = await axios.put(Conf.backendURL + "patron", patron);
    if (result.data.error) alert(result.data.error);
    else {
      alert("Save Completed");
      setPatron({});
    }
  }
  async function deletePatron() {
    if (window.confirm("Confirm to delete")) {
      let result = await axios.delete(Conf.backendURL + "patron/" + patron._id);
      if (result.data.error) alert(result.data.error);
      else {
        console.log(result);
        alert("Delete Completed");
        setPatron({});
      }
    }
  }
  return (
    <div style={{ marginTop: "15px" }}>
      {patron && (
        <>
          <Grid container spacing={2}>
            <Grid item xs={4}>
              <TextField
                fullWidth
                label="CMU IT Account"
                variant="outlined"
                size="small"
                value={patron.cmu_account || ""}
                onChange={(e) =>
                  setPatron({ ...patron, cmu_account: e.target.value })
                }
                onKeyUp={(e) => e.key === "Enter" && searchAccount()}
                InputProps={{
                  style: { paddingRight: "0px" },
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton color="primary" onClick={searchAccount}>
                        <Icon>search</Icon>
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </Grid>

            <Grid item xs={4}>
              <TextField
                fullWidth
                label="Student Id"
                variant="outlined"
                size="small"
                value={patron.student_id || ""}
                onChange={(e) =>
                  setPatron({ ...patron, student_id: e.target.value })
                }
                onKeyUp={(e) => e.key === "Enter" && searchStudentId()}
                InputProps={{
                  style: { paddingRight: "0px" },
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton color="primary" onClick={searchStudentId}>
                        <Icon>search</Icon>
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </Grid>

            <Grid item xs={4}>
              <TextField
                fullWidth
                label="CMU e-Mail"
                variant="outlined"
                size="small"
                value={patron.cmu_email || ""}
                onChange={(e) =>
                  setPatron({ ...patron, cmu_email: e.target.value })
                }
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </Grid>
            <Grid item xs={4}>
              <TextField
                fullWidth
                label="Prefix"
                variant="outlined"
                size="small"
                value={patron.prefix || ""}
                onChange={(e) =>
                  setPatron({ ...patron, prefix: e.target.value })
                }
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </Grid>
            <Grid item xs={4}>
              <TextField
                fullWidth
                label="First name"
                variant="outlined"
                size="small"
                value={patron.first_name || ""}
                onChange={(e) =>
                  setPatron({ ...patron, first_name: e.target.value })
                }
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </Grid>
            <Grid item xs={4}>
              <TextField
                fullWidth
                label="Last name"
                variant="outlined"
                size="small"
                value={patron.last_name || ""}
                onChange={(e) =>
                  setPatron({ ...patron, last_name: e.target.value })
                }
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </Grid>
            <Grid item xs={4}>
              <TextField
                fullWidth
                label="Organization"
                variant="outlined"
                size="small"
                value={patron.organization || ""}
                onChange={(e) =>
                  setPatron({ ...patron, organization: e.target.value })
                }
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </Grid>
            <Grid item xs={4}>
              <TextField
                fullWidth
                label="Department"
                variant="outlined"
                size="small"
                value={patron.department || ""}
                onChange={(e) =>
                  setPatron({ ...patron, department: e.target.value })
                }
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </Grid>
            <Grid item xs={4}>
              <TextField
                fullWidth
                label="Position"
                variant="outlined"
                size="small"
                value={patron.position || ""}
                onChange={(e) =>
                  setPatron({ ...patron, position: e.target.value })
                }
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </Grid>
            <Grid item xs={3}>
              <TextField
                fullWidth
                label="Barcode"
                variant="outlined"
                size="small"
                value={patron.patron_code || ""}
                onChange={(e) =>
                  setPatron({ ...patron, patron_code: e.target.value })
                }
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </Grid>
            <Grid item xs={3}>
              <TextField
                fullWidth
                label="Patron Id"
                variant="outlined"
                size="small"
                placeholder="pxxxxxxxx"
                value={patron.patron_id || ""}
                onChange={(e) =>
                  setPatron({ ...patron, patron_id: e.target.value })
                }
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </Grid>
            <Grid item xs={3}>
              <TextField
                fullWidth
                label="Phone Number 1"
                variant="outlined"
                size="small"
                value={patron.phone || ""}
                onChange={(e) =>
                  setPatron({ ...patron, phone: e.target.value })
                }
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </Grid>
            <Grid item xs={3}>
              <TextField
                fullWidth
                label="Phone Number 2"
                variant="outlined"
                size="small"
                value={patron.phone2 || ""}
                onChange={(e) =>
                  setPatron({ ...patron, phone2: e.target.value })
                }
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </Grid>
            <Grid item xs={6}>
              <Button
                variant="contained"
                color="secondary"
                style={{
                  width: "120px",
                }}
                disabled={patron._id ? false : true}
                onClick={deletePatron}
              >
                Delete
              </Button>
            </Grid>
            <Grid item xs={6} align="right">
              <Button
                variant="contained"
                onClick={() => setPatron({})}
                style={{
                  width: "120px",
                  backgroundColor: "#26a69a",
                  color: "#fff",
                }}
              >
                Clear
              </Button>
              <Button
                variant="contained"
                color="primary"
                style={{ marginLeft: "5px", width: "120px" }}
                onClick={savePatron}
              >
                Save
              </Button>
            </Grid>
          </Grid>
        </>
      )}
    </div>
  );
}

/*

export default class Patron extends React.Component {
  state = {
    keyword: "",
    form: {
      first_name: "",
      last_name: "",
      email: "",
      student_id: "",
      patron_code: "",
      patron_id: "",
    },
    profile: {},
    patrons: [],
  };
  componentDidMount() {
    (async () => {
      if (cookie && cookie.admin_token) {
        let profile = await axios.get(Conf.signinURL + "me", {
          headers: {
            authorization: cookie.admin_token,
            "X-Requested-With": "profile",
          },
        });
        profile = profile.data.profile;
        if (
          !profile.OrganizationName2 === "ฝ่ายเทคโนโลยีสารสนเทศห้องสมุด" ||
          !profile.OrganizationName2 ===
            "หัวหน้าฝ่ายบริการและส่งเสริมการเรียนรู้"
        ) {
          window.location = Conf.frontendURL + "login";
        } else {
          this.setState({ profile });
        }
      } else {
        window.location = Conf.frontendURL + "login";
      }
    })();
  }
  goSearch(e) {
    var id = e.target.id;
    if (id === "keyword" && e.keyCode === 13) {
      var keyword = e.target.value;
      var query = {
        $or: [
          { first_name: { $regex: ".*" + keyword + ".*" } },
          { last_name: { $regex: ".*" + keyword + ".*" } },
          { patron_code: { $regex: ".*" + keyword + ".*" } },
          { email: { $regex: ".*" + keyword + ".*" } },
        ],
      };
      axios.post(Conf.backendURL + "patron", { query: query }).then((res) => {
        console.log(res);
        this.setState({ patrons: res.data, keyword: keyword });
      });
    }
  }
  selectPatron(patron) {
    var { form } = this.state;
    form = patron;
    console.log(patron);
    this.setState({ form: form, keyword: "" });
  }
  changeInput(e) {
    var id = e.target.id;
    var { form } = this.state;
    form[id] = e.target.value;
    this.setState({ form });
  }
  savePatron() {
    var { form } = this.state;
    axios.put(Conf.backendURL + "patron", form).then((res) => {
      if (res.data.error) alert(res.data.error);
      else {
        alert("Save Completed");
        this.clearForm();
      }
    });
  }
  clearForm() {
    this.setState({
      form: {
        first_name: "",
        last_name: "",
        email: "",
        student_id: "",
        patron_code: "",
        patron_id: "",
        phone: "",
      },
    });
  }
  render() {
    const { form, keyword, patrons } = this.state;
    return (
      <div>
        {this.state.profile.usn && (
          <>
            <Container maxWidth="lg">
              <Grid container spacing={1}>
                <Grid item xs={7}>
                  <h1>Patron Informations</h1>
                </Grid>
                <Grid item xs={5} style={{ paddingTop: "25px" }}>
                  <TextField
                    fullWidth
                    id="keyword"
                    label="Search"
                    variant="outlined"
                    placeholder="Keyword..."
                    onKeyUp={(e) => this.goSearch(e)}
                    InputLabelProps={{
                      shrink: true,
                    }}
                  />
                </Grid>
              </Grid>
              <hr style={{ borderBottom: "2px solid #333" }} />

              <div
                style={{
                  textAlign: "right",
                  fontSize: ".8rem",
                  fontWeight: 400,
                }}
              >
                {this.state.profile.usn.toUpperCase()} &nbsp; (
                <a href={Conf.frontendURL + "login"} style={{ color: "#f00" }}>
                  Sign Out
                </a>
                )
              </div>
              {keyword.trim() !== "" ? (
                <SearchForm
                  patrons={patrons}
                  selectPatron={(patron) => this.selectPatron(patron)}
                />
              ) : (
                <PatronForm
                  patron={form}
                  changeInput={(e) => this.changeInput(e)}
                  savePatron={() => this.savePatron()}
                />
              )}
            </Container>
          </>
        )}
      </div>
    );
  }
}

const PatronFormStyles = makeStyles((theme) => ({
  root: {
    "& .MuiTextField-root": {
      marginTop: theme.spacing(1),
    },
  },
  textField: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
  },
}));

function PatronForm(props) {
  const { patron, changeInput, savePatron } = props;
  const classes = PatronFormStyles();
  return (
    <div style={{ marginTop: "30px" }}>
      <form className={classes.root}>
        <Grid container spacing={1}>
          <Grid item xs={12} md={2}>
            <TextField
              fullWidth
              id="student_id"
              label="Student Id"
              variant="outlined"
              value={patron.student_id}
              onChange={(e) => changeInput(e)}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Grid>
          <Grid item xs={12} md={5}>
            <TextField
              required
              fullWidth
              id="first_name"
              label="First Name"
              variant="outlined"
              value={patron.first_name}
              onChange={(e) => changeInput(e)}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Grid>
          <Grid item xs={12} md={5}>
            <TextField
              required
              fullWidth
              id="last_name"
              label="Last Name"
              variant="outlined"
              value={patron.last_name}
              onChange={(e) => changeInput(e)}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Grid>

          <Grid item xs={12} md={3}>
            <TextField
              required
              fullWidth
              id="patron_id"
              label="Patron Id"
              variant="outlined"
              placeholder="PXXXXXXXXX"
              value={patron.patron_id}
              onChange={(e) => changeInput(e)}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Grid>
          <Grid item xs={12} md={3}>
            <TextField
              required
              fullWidth
              id="patron_code"
              label="Barcode"
              value={patron.patron_code}
              variant="outlined"
              onChange={(e) => changeInput(e)}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Grid>
          <Grid item xs={12} md={3}>
            <TextField
              required
              fullWidth
              id="email"
              label="CMU e-Mail"
              value={patron.email}
              variant="outlined"
              placeholder="username@cmu.ac.th"
              onChange={(e) => changeInput(e)}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Grid>
          <Grid item xs={12} md={3}>
            <TextField
              fullWidth
              id="phone"
              label="Phone Number"
              value={patron.phone}
              variant="outlined"
              onChange={(e) => changeInput(e)}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Grid>
        </Grid>

        <Fab
          variant="extended"
          color="primary"
          aria-label="add"
          style={{ marginTop: "30px" }}
          onClick={() => savePatron()}
        >
          Save Patron
        </Fab>
      </form>
    </div>
  );
}
class SearchForm extends React.Component {
  render() {
    const { patrons, selectPatron } = this.props;
    return (
      <div>
        <TableContainer component={Paper}>
          <Table size="small" aria-label="a dense table">
            <TableBody>
              {patrons.map((patron) => (
                <TableRow key={patron._id}>
                  <TableCell>{patron.first_name} </TableCell>
                  <TableCell>{patron.last_name}</TableCell>
                  <TableCell>{patron.patron_code}</TableCell>
                  <TableCell>{patron.email}</TableCell>
                  <TableCell style={{ width: "80px", textAlign: "center" }}>
                    <Fab
                      color="secondary"
                      aria-label="edit"
                      size="small"
                      onClick={() => selectPatron(patron)}
                    >
                      <EditIcon />
                    </Fab>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </div>
    );
  }
}
*/
